import { render, staticRenderFns } from "./base-swiper-item.vue?vue&type=template&id=0f0813f0&scoped=true"
import script from "./base-swiper-item.vue?vue&type=script&lang=js"
export * from "./base-swiper-item.vue?vue&type=script&lang=js"
import style0 from "./base-swiper-item.vue?vue&type=style&index=0&id=0f0813f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0813f0",
  null
  
)

export default component.exports